import React, { useState, useEffect } from "react";
import { Form, Table } from "react-bootstrap";

import MenuItem from "@material-ui/core/MenuItem";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
// import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import Media from "react-media";
import Pagination from "rc-pagination";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import { BottomNavigationMobile } from "../navigationSection/BottomNavigationMobile";
import { RightSideCountTop } from "../../superAdminComponents/superAdminAllComponent/superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import { item_reports } from "../../../store/actions/VendorReports/vendorReportsRestaurant";
import isEmpty from "../../../store/validation/is-Empty";
import SmallLoader from "../../Loader/SmallLoader";
import { ORDER_TYPE } from "../../../enums/OrderEnums";
import moment from "moment";
import { SortComponent } from "../../reusableComponents/SortAndFilterComponent/SortComponent";
import SelectFilter from "../../reusableComponents/selectFilter";
import BasicPagination from "../../Pagination/Pagination";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";

function CategoryReport(props) {
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [dateQuery, setDateQuery] = useState({
    // startDate: moment().format("YYYY-MM-DD"),
    // endDate: moment().format("YYYY-MM-DD"),
  });
  const [state, setState] = useState({
    search: "",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [restaurantReverse, setRestaurantReverse] = useState("");
  const [itemData, setitemData] = useState([]);

  let vendor_id = props?.vendorAccess?.vendor_id || props?.auth?.user?.VendorUser?._id;
  // console.log(vendor_id);

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
  };

  const onSearchChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const getData = () => {
    props.item_reports(props.auth.user.accessToken, vendor_id, dateQuery);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (value) => (e) => {
    setRestaurantReverse(value);
    console.log(restaurantReverse);
    handleClose();
  };

  useEffect(
    (async) => {
      const DateForm = {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      };
      if (!isEmpty(dateQuery)) {
        getData(
          props.auth.user.accessToken,
          dateQuery.startDate === "undefined" ? DateForm : dateQuery
        );
      }
    },
    [dateQuery]
  );

  let tempdata = [];
  // console.log(restaurantReverse);
  if (restaurantReverse === "A-Z") {
    tempdata =
      props?.item?.items &&
      props?.item?.items.sort((a, b) => {
        if (a.name !== null && b.name !== null) {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        }
      });
  } else if (restaurantReverse === "Z-A") {
    tempdata =
      props?.item?.items &&
      props?.item?.items.sort((a, b) => {
        if (a.name !== null && b.name !== null) {
          if (a.name < b.name) return 1;
          if (a.name > b.name) return -1;
          return 0;
        }
      });
  }

  tempdata =
    props?.item?.items &&
    props?.item?.items.filter((data) => {
      return data?.name.toLowerCase().includes(state.search.toLowerCase());
    });

  // console.log(props?.item?.stats && props?.item?.stats.totalAmount);

  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Category Reports</div>
                <div>
                  <div
                    className="f14-500 mb-2 d-flex justify-content-end align-items-end"
                    style={{ color: "#EE3A23" }}
                  >
                    {moment().format("lll")}
                  </div>
                  <RightSideCountTop
                    content={[
                      {
                        name: "Gross Amount",
                        value:
                          props?.item &&
                            props?.item?.stats &&
                            props?.item?.stats?.totalAmount
                            ? `₹ ${props?.item?.stats?.totalAmount}`
                            : "₹ 0",
                        backgroundColor: "#FFEDE9",
                        color: "#EE3A23",
                      },
                      {
                        name: <>Net Total Amount</>,
                        value:
                          props?.item &&
                            props?.item?.stats &&
                            props?.item?.stats?.totalAmount
                            ? `₹ ${props?.item?.stats?.totalAmount}`
                            : "₹ 0",
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      },
                      {
                        name: "Total tax Value",
                        value:
                          props?.item &&
                            props?.item?.stats &&
                            props?.item?.stats?.totalCount
                            ? `${props?.item?.stats?.totalCount}`
                            : "0",
                        backgroundColor: "#D8F3F4",
                        color: "#138B90",
                      },
                    ]}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <Paper component="form" className="enSearch2 d-flex">
                    <IconButton type="submit" aria-label="search">
                      <SearchIcon />
                    </IconButton>
                    <InputBase
                      placeholder="Search"
                      name="search"
                      inputProps={{
                        "aria-label": "Search by Name or Phone Number",
                      }}
                      onChange={onSearchChange}
                      value={state.search}
                    />
                  </Paper>
                </div>
                <div className="col-3"></div>
                <div className="col-3">
                  <div className="mr-3">
                    <SelectFilter onDateChange={onDateChangeHandler()} />
                  </div>
                </div>
                <div className="col-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="f10-400" align="center">
                      <SortComponent
                        handleClick={handleClick}
                        anchorEl={anchorEl}
                        handleClose={handleClose}
                        selectClick={(data) => handleSelect(data)}
                      />
                    </div>
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../assets/images/iconButton/filtericon.png")}
                        width="35px"
                      />
                      <br />
                      Filter
                    </div>
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../assets/images/iconButton/downloadicon.png")}
                        width="35px"
                      />
                      <br />
                      Download
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                  <Table className="HideShowTable enMinWidth900">
                    <thead style={{ fontSize: "10px" }}>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "380px" }} className="f12-700">
                          Category ID
                        </th>
                        <th style={{ width: "180px" }} className="f12-700">
                          Category
                          <br /> Name
                        </th>
                        <th style={{ width: "180px" }} className="f12-700">
                          No. Of
                          <br /> Items
                        </th>
                        <th style={{ width: "180px" }} className="f12-700">
                          Cross Selling
                          <br />
                          Categories
                        </th>
                        <th style={{ width: "180px" }} className="f12-700">
                          Product Classigication
                          <br /> Reviews
                        </th>
                        <th style={{ width: "180px" }} className="f12-700">
                          Global
                          <br /> Classification
                        </th>
                      </tr>
                    </thead>
                    {props.auth.secondary_loader ? (
                      <SmallLoader />
                    ) : (
                      !isEmpty(tempdata) &&
                      tempdata.slice(start, end).map((data, index) => {
                        // console.log(data);
                        return (
                          <tbody key={index}>
                            <tr className="super_admin_all_users_table_body">
                              <td style={{ width: "380px" }} className="f9-400">
                                {data?._id}
                              </td>
                              <td
                                style={{ width: "180px" }}
                                className="f12-500"
                              >
                                {data?.name}
                              </td>
                              <td
                                style={{ width: "180px" }}
                                className="f12-500"
                              >
                                ₹ {data?.size && data?.size[0]?.price}
                              </td>
                              <td
                                style={{ width: "180px" }}
                                className="f12-500"
                              >
                                {data?.availability}
                              </td>
                              <td
                                style={{ width: "180px" }}
                                className="f12-500"
                              >
                                <b>4.2</b>(550 reviews)
                              </td>
                              <td
                                style={{ width: "180px" }}
                                className="f12-500"
                              >
                                {data?.view_count}
                              </td>
                            </tr>
                          </tbody>
                        );
                      })
                    )}
                  </Table>
                </div>
              </div>

              <div className="p4v2-menu-pagination">
                <BasicPagination
                  totalRecords={props?.item?.items?.length}
                  limit={5}
                  batch={page}
                  onBatchChange={(e) => handleBatchChange(e)}
                />
              </div>
            </div>
          </div>
          <Media query="(max-width: 991px)">
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </Media>
        </div>
      </div>
    </React.Fragment>
  );
}

CategoryReport.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  item: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  item: state.reports.vendor_item_report,
  auth: state.auth,
  errors: state.errors.errors,
  vendorAccess: state.vendorAccess
});

export default connect(mapStateToProps, {
  clear_all_errors,
  item_reports,
})(CategoryReport);

// export default CategoryReport;
